import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Tooltip,
  TooltipProps,
  tooltipClasses,
  TablePagination,
  TableFooter,
  TextField
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Device, RefactoredDevice } from '../../@types/model/device';
import dayjs from 'dayjs';
import { generatePath, NavLink, useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../routes/paths';
import { Fragment, useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import BasicModal from '../BasicModal';
import Typography from '@mui/material/Typography';
import ShareWithUserForm from '../ShareWithUserForm';
import LoadingSpinner from '../LoadingSpinner';
import { CancelToken } from 'axios';
import axios from '../../utils/axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { ROLE_END_USER, checkModules } from 'guards/CheckRoles';
import './../../assets/css/repsol.scss';
import refactorDevices from './Components/refactorDevices';
import SvgIconStyle from 'components/SvgIconStyle';
import relativeTime from 'dayjs/plugin/relativeTime';
import { apiConfig } from 'config';
import shareDevice from './Components/shareDevice';
import { Stack } from '@mui/material';
import DeviceStatePicker from 'components/DeviceStatePicker';
import LabelPicker from 'components/label/LabelPicker';
import DeviceGroupPicker from 'components/DeviceGroupPicker';
import WorkspacePicker from 'components/WorkspacePicker';
import DeviceProvincePicker from 'components/DeviceProvincePicker';
import { checkRoles } from 'guards/CheckRoles';
import { ROLE_USER } from 'guards/CheckRoles';
import { DeviceTag } from '../../@types/model/user';
import { IconButton } from '@mui/material';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

let cancel: any;

interface DeviceTableProps {
  onFilterChange: (filter: Device[]) => void | undefined;
  filterDevices: Boolean;
}

export type DeviceTableFilter = {
  text: string | undefined;
  deviceGroup: string | undefined;
  workspace: string | undefined;
  state: string;
  order_by: string;
  tag: string | undefined;
  direction: 'asc' | 'desc';
  province: string | undefined;
};

export type Location = {
  lat: number;
  lon: number;
  city: string;
};

dayjs.extend(relativeTime);

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}));

const DeviceTableRepsol = (props: DeviceTableProps) => {
  const [locations, setLocations] = useState<Location[]>([]);
  const [devices, setDevices] = useState<Device[]>([]);
  const [, setItems] = useState<Device[]>([]);
  const [refactoredDevices, setRefactoredDevices] = useState<RefactoredDevice[]>([]);
  const [totalDeviceCount, setTotalDeviceCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(100);

  const { loaded, deviceTags, user } = useSelector((state: RootState) => state.user);
  const { workspace } = useSelector((state: RootState) => state.workspace);

  const [deviceToShare, setDeviceToShare] = useState<Device | null>(null);
  const [shareLoading, setShareLoading] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const TIPOS_SECTOR_RECURRENCIA = [t('each_8_hours'), t('each_4_hours'), t('each_12_hours')];

  const [tableFilter, setTableFilter] = useState({
    deviceGroup: undefined,
    tag: undefined,
    order_by: 'last_data.data.Percent',
    state: 'any',
    direction: 'asc',
    text: undefined,
    province: undefined
  } as DeviceTableFilter);

  const [provinceList, setProvinceList] = useState([]);
  const getProvinceList = () => {
    if (provinceList.length === 0) {
      axios
        .get('/api/v2/device/states')
        .then((res) => {
          let provinceL = res.data.data.map((c: any) => c.states);

          provinceL = Array.prototype.concat(...provinceL);

          setProvinceList(provinceL);
        })
        .catch((err) => console.log(err));
    }
  };

  const getDevices = async (
    page: number,
    size: number,
    okCallback: (deviceGroups: Device[], totalCount: number) => void,
    koCallback: (error: any) => void,
    cancelable = true,
    filter: DeviceTableFilter | null = null,
    exportFormat: string | null = null
  ): Promise<void> => {
    if (cancel) {
      cancel.cancel();
    }
    if (cancelable) {
      // @ts-ignore
      cancel = CancelToken.source();
    }
    const queryParams: any = {
      offset: page * size,
      size
    };

    if (filter) {
      queryParams.order_by = filter.order_by;
      queryParams.direction = filter.direction;
    }
    if (filter && filter.deviceGroup) {
      queryParams.tags = [filter.deviceGroup];
    }
    if (filter && filter.tag) {
      queryParams.tags = [filter.tag];
    }

    if (filter && filter.workspace) {
      queryParams.workspace = filter.workspace;
    }

    if (filter && filter.state) {
      queryParams.state = filter.state;
    }

    if (filter && filter.text) {
      queryParams.text = filter.text;
    }

    if (filter && filter.province) {
      queryParams.provincia = filter.province;
    }
    // if (exportFormat) {
    //   queryParams.format = exportFormat;
    // }
    setLoading(true);
    await axios
      .get('/api/v2/device', {
        cancelToken: cancelable ? cancel.token : null,
        params: queryParams
      })
      .then(({ data }: any) => {
        okCallback(
          data.data.map((item: any) => {
            return item as Device;
          }),
          data.meta.total_count
        );
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const downloadExcelDevices = async (): Promise<void> => {
    let url = `${apiConfig.apiBaserl}/api/v2/device/report`;

    axios({
      url: url,
      method: 'POST',
      responseType: 'blob', // important
      data: {
        devices: '',
        fields: 'identifier,state,percent,available,last_data,capacity,free_space,remain',
        temporal_interval: 'anual',
        type: 'repsol',
        u: user!.id,
        date: dayjs().unix(),
        s: '',
        device: ''
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        setExportInProgress(false);
      })
      .catch((exception) => {
        enqueueSnackbar(t('download_failed'), { variant: 'error' });
        setExportInProgress(false);
      });
  };

  useEffect(() => {
    getDevices(
      page,
      itemsPerPage,
      async (data: Device[], count: number) => {
        setDevices(data);
        setTotalDeviceCount(count);
        setItems(data);
        if (props.onFilterChange) {
          props.onFilterChange(data);
        }

        getProvinceList();
      },
      () => {},
      true,
      tableFilter,
      'xls'
    );
  }, [page, itemsPerPage, tableFilter]);

  useEffect(() => {
    let locationsJSON = localStorage.getItem('locations');
    if (locationsJSON) setLocations(JSON.parse(locationsJSON));

    let refactoredDevices: RefactoredDevice[] = refactorDevices(devices);
    if (tableFilter.order_by === 'last_data.data.Percent') {
      if (tableFilter.direction === 'asc')
        refactoredDevices.sort((a: RefactoredDevice, b: RefactoredDevice) => a.percent - b.percent);
      else
        refactoredDevices.sort((a: RefactoredDevice, b: RefactoredDevice) => b.percent - a.percent);
    }

    setRefactoredDevices(refactoredDevices);
  }, [devices]);

  useEffect(() => {}, [locations]);

  const handleSortChange = (columnName: string) => {
    if (tableFilter.order_by === columnName) {
      setTableFilter({
        deviceGroup: undefined,
        tag: undefined,
        order_by: tableFilter.order_by,
        state: 'any',
        direction: tableFilter.direction === 'asc' ? 'desc' : 'asc',
        text: undefined,
        province: undefined
      } as DeviceTableFilter);
    } else {
      setTableFilter({
        deviceGroup: undefined,
        tag: undefined,
        order_by: columnName,
        state: 'any',
        direction: 'asc',
        text: undefined,
        province: undefined
      } as DeviceTableFilter);
    }
  };

  if (!loaded) {
    return <LoadingSpinner />;
  }

  //https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&key=AIzaSyBgzhkeaSVRBjXpdYzhiZJOYc1TW48Vz0o&result_type=locality

  return (
    <Fragment>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          marginBottom: '10px'
        }}
      >
        <Tooltip title={t('devices_export').toString()}>
          <Button
            disabled={exportInProgress}
            sx={{
              color: '#637381',
              borderColor: '#637381',
              marginRight: '24px',
              alignSelf: 'flex-end',
              width: '250px',
              height: '55px'
            }}
            variant={'outlined'}
            onClick={() => {
              setExportInProgress(true);
              getDevices(
                0,
                totalDeviceCount,
                (data: Device[], count: number) => {
                  setExportInProgress(false);
                },
                (error: any) => {
                  setExportInProgress(false);
                  enqueueSnackbar(t('download_failed'), { variant: 'error' });
                },
                true,
                tableFilter,
                'xls'
              );
            }}
          >
            {exportInProgress ? (
              <CircularProgress size={30} sx={{ marginRight: '20px' }} />
            ) : (
              <SvgIconStyle
                src="/static/icons/giraf/download.svg"
                sx={{ width: '20px', height: '20px', display: 'block', marginRight: '10px' }}
              />
            )}
            {t('devices_export').toString()}
          </Button>
        </Tooltip>
      </div>
      <Stack className="filter_container" direction={'row'} sx={{ width: '100%', padding: '10px' }}>
        <TextField
          sx={{ minWidth: '200px' }}
          type="text"
          value={tableFilter.text}
          label={t('search').toString()}
          onChange={(event) => setTableFilter({ ...tableFilter, text: event.target.value })}
        />
        <DeviceStatePicker
          selection={tableFilter.state}
          changeHandler={(state) => {
            setTableFilter({ ...tableFilter, state });
          }}
        />
        <LabelPicker
          selection={tableFilter.tag}
          changeHandler={(tagGuid: string | undefined) => {
            setTableFilter({ ...tableFilter, tag: tagGuid });
          }}
        />
        <DeviceGroupPicker
          deviceGroupGuid={tableFilter.deviceGroup}
          changeHandler={(deviceGroupGuid) => {
            if (deviceGroupGuid) {
              setTableFilter({ ...tableFilter, deviceGroup: deviceGroupGuid });
            } else {
              setTableFilter({ ...tableFilter, deviceGroup: undefined });
            }
          }}
          deviceTags={[]}
        />
        <WorkspacePicker
          workspaces={user!.attributes.workspaces}
          selectedWorkspace={tableFilter.workspace}
          changeHandler={(wks: string | null) => {
            if (wks) {
              setTableFilter({ ...tableFilter, workspace: wks });
            } else {
              setTableFilter({ ...tableFilter, workspace: undefined });
            }
          }}
        />
        <DeviceProvincePicker
          deviceProvince={tableFilter.province}
          changeHandler={(deviceProvince: any) => {
            if (deviceProvince) setTableFilter({ ...tableFilter, province: deviceProvince });
            else setTableFilter({ ...tableFilter, province: undefined });
          }}
          // provinceList={provinceList}
        />
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              onClick={() => handleSortChange('name')}
              style={{ cursor: 'pointer', position: 'relative' }}
            >
              {t('deposit')}
              {tableFilter.order_by === 'name' &&
                (tableFilter.direction === 'asc' ? (
                  <ArrowDropUpIcon style={{ position: 'absolute', top: 20 }} />
                ) : (
                  <ArrowDropDownIcon style={{ position: 'absolute', top: 20 }} />
                ))}
            </TableCell>
            <TableCell>{t('place')}</TableCell>
            <TableCell>{t('groups')}</TableCell>
            <TableCell
              onClick={() => handleSortChange('last_data.date')}
              style={{ cursor: 'pointer', position: 'relative' }}
            >
              <Typography align="center" variant="inherit">
                {t('last_measurement')}
                {tableFilter.order_by === 'last_data.date' &&
                  (tableFilter.direction === 'asc' ? (
                    <ArrowDropUpIcon style={{ position: 'absolute', top: 20 }} />
                  ) : (
                    <ArrowDropDownIcon style={{ position: 'absolute', top: 20 }} />
                  ))}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography align="center" variant="inherit">
                {t('recurrence_measurement')}
              </Typography>
            </TableCell>
            <TableCell
              onClick={() => handleSortChange('last_data.data.Percent')}
              style={{ cursor: 'pointer', position: 'relative' }}
            >
              {t('fill_state')}
              {tableFilter.order_by === 'last_data.data.Percent' &&
                (tableFilter.direction === 'asc' ? (
                  <ArrowDropUpIcon style={{ position: 'absolute', top: 20 }} />
                ) : (
                  <ArrowDropDownIcon style={{ position: 'absolute', top: 20 }} />
                ))}
            </TableCell>
            <TableCell>
              <Typography align="center" variant="inherit">
                {t('last_fill')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography align="center" variant="inherit">
                {t('fill_prevision')}
              </Typography>
            </TableCell>
            <TableCell>
              <Button
                disabled={exportInProgress}
                sx={{ color: '#637381', borderColor: '#637381' }}
                variant={'outlined'}
                onClick={() => {
                  setExportInProgress(true);
                  downloadExcelDevices();
                }}
              >
                {exportInProgress ? (
                  <CircularProgress size={30} />
                ) : (
                  <SvgIconStyle
                    src="/static/icons/giraf/download.svg"
                    sx={{ width: '20px', height: '20px', display: 'block' }}
                  />
                )}
              </Button>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody style={{ position: 'relative' }}>
          {loading && (
            <div className="tableLoading">
              <CircularProgress />
            </div>
          )}
          {refactoredDevices.map((rd: RefactoredDevice, index: number) => {
            let lastContact = <span style={{ color: 'red' }}>{t('never')}</span>;
            if (rd.attributes?.last_data && rd.attributes?.last_data.date) {
              if (dayjs().diff(rd.attributes?.last_data.date, 'hour') > 24) {
                lastContact = (
                  <span style={{ color: 'red' }}>
                    {dayjs(rd.attributes?.last_data.date).fromNow(true)}
                  </span>
                );
              } else {
                lastContact = <span>{dayjs(rd.attributes?.last_data.date).fromNow(true)}</span>;
              }
            }
            let deviceGuid = rd.guid;
            if (rd.attributes.is_ref_of) {
              if (user?.attributes.configuration?.allow_edit_shared_devices) {
                if (rd.attributes.is_ref_of.split(':').length === 3) {
                  deviceGuid = rd.attributes.is_ref_of.split(':')[2];
                }
              }
            }
            let tags = rd.attributes.tags
              .map((tId: string) => {
                const deviceTag = deviceTags.find((dt: DeviceTag) => dt.guid === tId);
                if (deviceTag) {
                  return deviceTag.attributes.name;
                }
                return null;
              })
              .filter((t) => t);
            tags = tags.filter((item: any, index: any) => tags.indexOf(item) === index);
            return (
              <TableRow key={rd.guid + '--' + index}>
                <TableCell>
                  <Tooltip title={rd.attributes.name + ' (' + rd.attributes.identifier + ')'}>
                    {checkRoles(user, ROLE_USER) ? (
                      <NavLink
                        to={generatePath(PATH_DASHBOARD.devices.details, {
                          guid: rd.guid
                        })}
                        className="btn-identifier"
                      >
                        {rd.attributes.name}
                      </NavLink>
                    ) : (
                      <NavLink
                        to={generatePath(PATH_DASHBOARD.end_user.devices.details, {
                          guid: rd.guid
                        })}
                        className="btn-identifier"
                      >
                        {rd.attributes.name}
                      </NavLink>
                    )}
                  </Tooltip>
                </TableCell>
                <TableCell>{rd?.attributes.last_location?.administrative_area_level_2}</TableCell>
                <TableCell>{tags.join(', ')}</TableCell>
                <TableCell sx={{ minWidth: 155 }}>
                  <Typography align="center" variant="inherit">
                    {rd.attributes?.last_data && rd.attributes?.last_data.date && (
                      <>{lastContact}</>
                    )}
                  </Typography>
                </TableCell>
                <TableCell>
                  {rd?.sector && rd?.sector !== -1 ? (
                    <Typography align="center">{TIPOS_SECTOR_RECURRENCIA[rd?.sector]}</Typography>
                  ) : (
                    <Typography align="center">-</Typography>
                  )}
                </TableCell>
                <TableCell>
                  <HtmlTooltip
                    title={
                      <Fragment>
                        <Typography color="inherit">{t('device_information')}</Typography>
                        <div>
                          <b>{t('capacity')}</b>: {rd.capacidad}
                        </div>
                        <div>
                          <b>{t('available_charge')}</b>: {Math.round(rd.volumen_aproximado)} L
                        </div>
                        <div>
                          <b>{t('free_space')}</b>: {Math.round(rd.volumen_libre)} L
                        </div>
                      </Fragment>
                    }
                  >
                    <div style={{ display: 'flex' }}>
                      <div
                        style={{
                          background:
                            rd.percent >= 50 ? '#008080' : rd.percent >= 20 ? '#ffcc00' : '#aa0000',
                          color: 'white',
                          padding: '10px 5px',
                          borderRadius: 10,
                          width: 64,
                          textAlign: 'center',
                          maxHeight: 40
                        }}
                      >
                        {Math.round(rd.percent * 10) / 10}%
                      </div>
                      {rd.capacidad && rd.capacidad !== 0 ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginLeft: 10,
                            justifyContent: 'center',
                            color: '#868588'
                          }}
                        >
                          <span style={{ fontWeight: 700 }}>
                            <> {Math.round((rd.capacidad * (100 - rd.percent)) / 100)} L</>
                          </span>
                          <span>{t('free_space')}</span>
                        </div>
                      ) : null}
                    </div>
                  </HtmlTooltip>
                </TableCell>
                <TableCell className="center">
                  <Typography align="center">-</Typography>
                </TableCell>
                <TableCell className="center">
                  <Typography align="center">-</Typography>
                </TableCell>
                <TableCell>
                  {checkRoles(user, ROLE_END_USER) && checkModules(workspace, ['orders']) ? (
                    <Button
                      onClick={() => {
                        navigate(PATH_DASHBOARD.end_user.deliver.new);
                      }}
                      disabled={true}
                      style={{
                        // background: 'var(--navSectionBackground)',
                        background: 'gray',
                        color: 'white',
                        marginTop: 10,
                        maxWidth: 200,
                        whiteSpace: 'nowrap'
                      }}
                      variant={'contained'}
                    >
                      {t('request_gasoil')}
                    </Button>
                  ) : null}
                  {checkRoles(user, ROLE_USER) ? (
                    <IconButton
                      component={NavLink}
                      disabled={
                        rd.attributes.is_ref_of !== null &&
                        !user?.attributes.configuration?.allow_edit_shared_devices
                      }
                      to={generatePath(PATH_DASHBOARD.devices.edit, { guid: deviceGuid })}
                    >
                      <SvgIconStyle
                        src="/static/icons/giraf/edit.svg"
                        sx={{ width: '20px', height: '20px' }}
                      />
                    </IconButton>
                  ) : null}
                  {checkRoles(user, ROLE_USER) ? (
                    <IconButton
                      onClick={() => {
                        setDeviceToShare(rd);
                      }}
                    >
                      <SvgIconStyle
                        src="/static/icons/giraf/share.svg"
                        sx={{ width: '20px', height: '20px' }}
                      />
                    </IconButton>
                  ) : null}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              count={totalDeviceCount}
              rowsPerPage={itemsPerPage}
              page={page}
              onPageChange={(event: any, page: number) => {
                setPage(page);
              }}
              onRowsPerPageChange={(event: any) => {
                setPage(0);
                setItemsPerPage(parseInt(event.target.value, 10));
              }}
            />
          </TableRow>
        </TableFooter>
      </Table>
      <BasicModal
        open={deviceToShare !== null}
        handleClose={() => {
          setDeviceToShare(null);
        }}
      >
        {deviceToShare ? (
          <Fragment>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {t('share')} {deviceToShare.attributes.name} ({deviceToShare.attributes.identifier})
            </Typography>
            <ShareWithUserForm
              submitHander={(name: string, email: string) => {
                setShareLoading(true);
                shareDevice(
                  deviceToShare.guid,
                  name,
                  email,
                  () => {
                    setShareLoading(false);
                    setDeviceToShare(null);
                    enqueueSnackbar(t('device_shared_successfuly'), { variant: 'success' });
                  },
                  (error) => {
                    setShareLoading(false);
                    enqueueSnackbar(error.message, { variant: 'error' });
                  }
                );
              }}
              loading={shareLoading}
            />
          </Fragment>
        ) : null}
      </BasicModal>
    </Fragment>
  );
};

export default DeviceTableRepsol;
